// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:59:26

export default {
  "id": "crazy-bus-station",
  "slug": "crazy-bus-station",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/27839b78f17a4adf8b1b0efe330b7887-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/27839b78f17a4adf8b1b0efe330b7887/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Crazy Bus Station",
      "description": "Embark on a thrilling puzzle adventure! Maneuver buses through challenging parking lots, match cars with their passengers, and clear the path. Unlock unique vehicles, tackle puzzles of all difficulty levels, and use boosters to sort or shuffle when needed. With vibrant graphics and creative gameplay, this game offers fun for players of all ages!",
      "instructions": "Match cars with passengers and clear the parking lot! Click to move cars in the arrow's direction but ensure the path is clear. Use boosters to sort or shuffle when stuck!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "bus",
        "logic",
        "parking",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "疯狂巴士站",
      "description": "踏上激动人心的解谜冒险之旅！操控公交车穿梭于挑战性的停车场，匹配车辆与乘客，清除道路。解锁独特车辆，挑战各种难度级别的谜题，并在必要时使用助推器进行排序或洗牌。凭借鲜艳的图形和创意玩法，这款游戏为所有年龄段的玩家带来乐趣！",
      "instructions": "匹配车辆与乘客，清理停车场！点击将车辆移动到箭头指示的方向，但确保路径畅通。使用助推器在卡住时进行排序或洗牌！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "公交车",
        "逻辑",
        "停车",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "瘋狂巴士站",
      "description": "踏上刺激的益智冒險！操控巴士穿越挑戰性的停車場，將車輛與乘客匹配，清除道路。解鎖獨特車輛，挑戰各種難度等級的謎題，並在需要時使用加強器進行排序或洗牌。這款遊戲擁有生動的圖像和創新的遊戲玩法，適合所有年齡段的玩家享受樂趣！",
      "instructions": "將車輛與乘客配對，清空停車場！點擊將車輛移動到箭頭的方向，但確保路徑畅通。使用加強器在卡住時進行排序或打亂！",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "巴士",
        "邏輯",
        "停車",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "瘋狂巴士站",
      "description": "啟航於刺激的謎題冒險！操縱巴士穿梭於挑戰性的停車場，匹配車輛與乘客，清除道路。解鎖獨特車輛，挑戰各種難度的謎題，並在需要時使用加強器進行排序或洗牌。這款遊戲以生動的圖像和創意的遊戲玩法，為各年齡層的玩家帶來樂趣！",
      "instructions": "配對車輛與乘客，清空停車場！點擊移動車輛至箭頭方向，但確保路徑畅通。使用加強器排序或混亂時受阻！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "巴士",
        "邏輯",
        "停車",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "クレイジーバスステーション",
      "description": "興奮するパズルアドベンチャーに参加して！難しい駐車場を通してバスを操縦し、車と乗客を一致させ、道を開放しましょう。ユニークな車両を解錠し、様々な難易度のパズルに挑戦し、必要に応じてブースターを使って並べ替えたりシャッフルしたりします。鮮やかなグラフィックと創造的なゲームプレイで、全ての年齢層のプレイヤーに楽しんでもらえるゲームです！",
      "instructions": "乗客と車を一致させ、駐車場を空ける！矢印の方向に車を移動させるが、通路が確保する必要があります。行き詰ったらブースターを使って並べ替えたりシャッフルしたりしてください！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "バス",
        "ロジック",
        "駐車",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "cray 버스 정류장",
      "description": "thrilling puzzle adventure에 오세요! 어려운 주차장을 통과시키는 버스를 조종하고, 차량과 승객을 일치시키며 길을 확보하세요. 독특한 차량을 해금하고, 모든 난이도의 퍼즐을 해결하고 필요 시 보스터를 사용하여 정렬이나 섞어주세요. 생동감 넘치는 그래픽과 창의적인 게임 플레이로, 모든 연령대의 플레이어에게 즐거움을 제공합니다!",
      "instructions": "승객과 차량을 매칭하여 주차장을 청소하세요! 아이콘을 클릭하여 차량을矢印 방향으로 이동시키지만, 통로가 열려 있는지 확인하세요. 고장났을 때는 보스터를 사용하여 정리하거나 섞어 주세요!",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "버스",
        "로직",
        "주차",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Gare folle",
      "description": "Embarkez sur une aventure de puzzle captivante ! Manoeuvrez les autobus à travers des parkings délicats, associez les voitures à leurs passagers, et libérez le chemin. Débloquez des véhicules uniques, affrontez des puzzles de tous les niveaux de difficulté, et utilisez des boosters pour classer ou mélanger lorsque nécessaire. Avec des graphismes vibrants et un gameplay créatif, ce jeu offre du plaisir aux joueurs de tous âges !",
      "instructions": "Matchez les voitures avec les passagers et videz le parking ! Cliquez pour déplacer les voitures dans le sens de la flèche, mais assurez-vous que le chemin est dégagé. Utilisez les boosters pour classer ou mélanger lorsque vous êtes bloqué !",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "bus - bus\nlogic - logique\nparking - stationnement\nsliding-puzzle - puzzle glissant"
      ]
    }
  }
};
